// These must exactly match the C# DataNotificationConstants values
// in BackendServices/.../DataNotificationConstants.cs
export const SignalREvents = {
  GingrIntegrationHealthCheck: 'GingrIntegrationHealthCheck',
  GingrOwnerStaged: 'GingrOwnerStaged',
  GingrOwnerImportStarted: 'GingrOwnerImportStarted',
  GingrOwnerImportCompleted: 'GingrOwnerImportCompleted',
  GingrPetStaged: 'GingrPetStaged',
  GingrPetImportStarted: 'GingrPetImportStarted',
  GingrReservationImportStarted: 'GingrReservationImportStarted',
  GingrReservationImportCompleted: 'GingrReservationImportCompleted',
  GingrImportCompleted: 'GingrImportCompleted',
  FacilitySuites: 'FacilitySuites',
  FacilitySuiteGroups: 'FacilitySuiteGroups',
  FacilitySuiteGroupClusters: 'FacilitySuiteGroupClusters',
  FacilitySuiteGroupClusterTimings: 'FacilitySuiteGroupClusterTimings',
  ChatMessage: 'ReceiveChatMessageUpdate',
  ChatMessageDeleted: 'ReceiveChatMessageDeletedUpdate',
  ChatConversation: 'ReceiveChatConversationUpdate',
  ChatRead: 'ReceiveChatReadUpdate',
  ChatReaction: 'ReceiveChatReactionUpdate',
} as const;

export const SignalRMethods = {
  JoinDataNotificationGroup: 'JoinDataNotificationGroup',
  LeaveDataNotificationGroup: 'LeaveDataNotificationGroup',
} as const;
